import { embeddedValue } from '@interhyp/api-values';

export function useIsEmbedded(): boolean {
  const [embedded] = embeddedValue.useValue();
  return embedded ?? false;
}
